import richText from "utilities/richText"
import Image from "components/Image"
import LazyVideo from "components/LazyVideo"

export default function Hero({ blok }) {
  return (
    <section className="relative z-10 bg-stone lg:min-h-[440px]">
      <div className="w-full flex justify-end lg:absolute top-0 left-0 bottom-0 right-0 h-full">
        <div className="lg:w-1/2 w-full">
          {blok.video.filename ? (
            <LazyVideo
              className="pointer-events-none relative w-full object-cover lg:h-[650px]"
              poster={blok.image.filename}
              sources={[
                { src: blok.video.filename, type: "video/webm; codecs=av01.0.05M.08" },
                { src: blok.video_fallback.filename, type: "video/mp4" },
              ]}
              autoPlay
              playsInline
              muted
              loop
            />
          ) : (
            <div className="inset-0 w-full h-full">
              <Image
                src={blok.image.filename}
                alt={blok.image.alt}
                width={1440}
                height={696}
                priority
                className="relative h-[250px] w-full object-cover object-center lg:h-full lg:min-h-[400px]"
              />
            </div>
          )}
        </div>
      </div>
      <div className="mx-auto max-w-screen-xl flex flex-col justify-center relative min-h-max z-20 p-8 lg:pb-20 lg:min-h-[400px]">
        <div className="prose-h1:leading-10 prose-h1:text-evergreen prose-p:py-5 prose-p:text-m2 prose-p:leading-6 prose-h1:lg:leading-[50px] max-w-xs">
          {richText(blok.content)}
        </div>
      </div>
    </section>
  )
}
